import { createApp } from 'vue'
import MemberMap from './components/MemberMap.vue'

const el = document.getElementById('member-map-app')
if (el) {
    const app = createApp(MemberMap, {
        membersUrl: el.dataset.membersUrl,
    })
    app.mount(el)
}
